// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.username-modal_modal-content_tFilA {
  width: 400px;
}

.username-modal_body_ri4su {
  background: var(--ui-modal-background);
  padding: 1.5rem 2.25rem;
}

.username-modal_body_ri4su input[type='checkbox'],
.username-modal_body_ri4su input[type='radio'] {
  margin: 3px;
}

.username-modal_text-input_AhrxL {
  margin-bottom: 1rem;
  width: 100%;
  border: 1px solid var(--ui-black-transparent);
  border-radius: 5px;
  padding: 0 1rem;
  height: 3rem;
  color: var(--ui-text-primary-transparent);
  font-size: 0.875rem;
  background-color: var(--input-background);
}

.username-modal_button-row_tfTr0 {
  font-weight: bolder;
  text-align: right;
}

.username-modal_button-row_tfTr0 button {
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  background: white;
  border: 1px solid var(--ui-black-transparent);
  font-weight: 600;
  font-size: 0.85rem;
}

.username-modal_button-row_tfTr0 button[disabled] {
  opacity: 0.5;
}

[dir='ltr'] .username-modal_button-row_tfTr0 button + button {
  margin-left: 0.5rem;
}

[dir='rtl'] .username-modal_button-row_tfTr0 button + button {
  margin-right: 0.5rem;
}

.username-modal_button-row_tfTr0 button.username-modal_ok-button_KYZWD {
  background: var(--looks-secondary);
  border: var(--looks-secondary);
  color: white;
}

.username-modal_button-row_tfTr0 button.username-modal_cancel-button_tBS3_ {
  color: black;
}

.username-modal_help-text_U8Akk {
  margin-bottom: 1rem;
}

.username-modal_must-change_I7D1c {
  font-weight: bold;
}

.username-modal_reset-link_cYBsK {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-username-modal/username-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n  width: 400px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 1.5rem 2.25rem;\n}\n\n.body input[type='checkbox'],\n.body input[type='radio'] {\n  margin: 3px;\n}\n\n.text-input {\n  margin-bottom: 1rem;\n  width: 100%;\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 5px;\n  padding: 0 1rem;\n  height: 3rem;\n  color: var(--ui-text-primary-transparent);\n  font-size: 0.875rem;\n  background-color: var(--input-background);\n}\n\n.button-row {\n  font-weight: bolder;\n  text-align: right;\n}\n\n.button-row button {\n  padding: 0.75rem 1rem;\n  border-radius: 0.25rem;\n  background: white;\n  border: 1px solid var(--ui-black-transparent);\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.button-row button[disabled] {\n  opacity: 0.5;\n}\n\n[dir='ltr'] .button-row button + button {\n  margin-left: 0.5rem;\n}\n\n[dir='rtl'] .button-row button + button {\n  margin-right: 0.5rem;\n}\n\n.button-row button.ok-button {\n  background: var(--looks-secondary);\n  border: var(--looks-secondary);\n  color: white;\n}\n\n.button-row button.cancel-button {\n  color: black;\n}\n\n.help-text {\n  margin-bottom: 1rem;\n}\n\n.must-change {\n  font-weight: bold;\n}\n\n.reset-link {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `username-modal_modal-content_tFilA`,
	"modalContent": `username-modal_modal-content_tFilA`,
	"body": `username-modal_body_ri4su`,
	"text-input": `username-modal_text-input_AhrxL`,
	"textInput": `username-modal_text-input_AhrxL`,
	"button-row": `username-modal_button-row_tfTr0`,
	"buttonRow": `username-modal_button-row_tfTr0`,
	"ok-button": `username-modal_ok-button_KYZWD`,
	"okButton": `username-modal_ok-button_KYZWD`,
	"cancel-button": `username-modal_cancel-button_tBS3_`,
	"cancelButton": `username-modal_cancel-button_tBS3_`,
	"help-text": `username-modal_help-text_U8Akk`,
	"helpText": `username-modal_help-text_U8Akk`,
	"must-change": `username-modal_must-change_I7D1c`,
	"mustChange": `username-modal_must-change_I7D1c`,
	"reset-link": `username-modal_reset-link_cYBsK`,
	"resetLink": `username-modal_reset-link_cYBsK`
};
export default ___CSS_LOADER_EXPORT___;
